import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

const MEASUREMENT_ID = 'G-C1TYNLHCSY';

function getAnalyticsConfig() {
  const configuredId = window.WConfiguration?.GA_MEASUREMENT_ID;
  const measurementId = configuredId || MEASUREMENT_ID;
  const isEnabled = window.WConfiguration?.ANALYTICS_ENABLED !== false;

  return { isEnabled, measurementId };
}

let initialized = false;

/**
 * Initialises ReactGA once, then fires a page_view on every route change.
 * Must be called from a component rendered inside <Router>.
 */
export function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    const { isEnabled, measurementId } = getAnalyticsConfig();

    if (!isEnabled || !measurementId) {
      return;
    }

    if (!initialized) {
      ReactGA.initialize(measurementId);
      initialized = true;
    }

    ReactGA.send({
      hitType: 'pageview',
      page: location.pathname + location.search,
      title: document.title,
    });
  }, [location]);
}

/** Reset initialisation state — for use in tests only. */
export function _resetForTesting() {
  initialized = false;
}
